import { z } from 'zod'

export const savedClubQuerySchema = z.object({
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).max(50).default(20),
})

export type SavedClubQueryInput = z.infer<typeof savedClubQuerySchema>
